import { render } from "./CheckStudentAssignment.vue?vue&type=template&id=67f9135e"
import script from "./CheckStudentAssignment.vue?vue&type=script&lang=js"
export * from "./CheckStudentAssignment.vue?vue&type=script&lang=js"

import exportComponent from "/voc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__